export function getFileIcon(extension) {
  switch (extension) {
    case 'pdf':
      return 'pdf';
    case 'xls':
    case 'xlsx':
      return 'table';
    case 'zip':
    case 'rar':
    case '7z':
      return 'archive';
    case 'txt':
    case 'doc':
    case 'docx':
    default:
      return 'text';
  }
}
